const dashboardContentStyles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  container: {
    maxHeight: 1000,
    marginTop: 0,
  },
  table: {
    minWidth: 700,
  },
  grid: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  button: {
    height: 40,
    margin: theme.spacing(1),
    borderRadius: 12,
  },
  datePicker: {
    margin: theme.spacing(1, 2),
  },
  formControl: {
    margin: 16,
    minWidth: 178,
  },
  textField: {
    margin: 16,
    minWidth: 178,
  },
  filterPaper: {
    padding: theme.spacing(1, 2),
    marginBottom: theme.spacing(2),
    borderRadius: 14,
    border: '1px solid #eef2f7',
    boxShadow: 'none',
    backgroundColor: '#fafbfe',
  },
})

export default dashboardContentStyles
